<body>
  <section>
    <div class="body-section">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-1"></div>
          <div class="col-lg-6">
            <div class="social-img">
              <a
                href="https://onpassive.com/blog"
                target="_blank"
                rel="noopener"
                title="ONPASSIVE Blog"
              >
                <img
                  class="blogicon"
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-06)/assets/image/icon/blog1.png"
                  alt="blog1"
                />
              </a>
              <a
                href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
                target="_blank"
                rel="noopener"
                title="Facebook"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-06)/assets/image/icon/fb.png"
                  alt="facebook"
                />
              </a>
              <a
                href="https://twitter.com/ONPASSIVE"
                target="_blank"
                rel="noopener"
                title="Twitter"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-06)/assets/image/icon/twitter.png"
                  alt="Twitter"
                />
              </a>
              <a
                href="https://www.instagram.com/ONPASSIVE/"
                target="_blank"
                rel="noopener"
                title="Instagram"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-06)/assets/image/icon/insta.png"
                  alt="Instagram"
                />
              </a>
              <a
                href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
                target="_blank"
                rel="noopener"
                title="Youtube"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-06)/assets/image/icon/youtube.png"
                  alt="YouTube"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
                target="_blank"
                rel="noopener"
                title="LinkedIn"
              >
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive(feb-06)/assets/image/icon/in.png"
                  alt="LinkedIn"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4 text-left">
            <div class="logo">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(feb-06)/assets/image/logo.png"
                alt="logo"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6 mt-5">
            <div class="row justify-content-center">
              <div class="col-lg-9">
                <div class="mob">
                  <h1 class="soon">Launching Soon</h1>
                  <h4 class="internet text-white mt-3">
                    The Cutting Edge Business Solution
                  </h4>
                  <p class="content2 text-white">
                    Companies prosper with the help of versatile and upgraded
                    tools, and that could also be challenging at times. We, at
                    ONPASSIVE, develop applications that can transform your
                    business into complete automation, which is self-aware and
                    upgrades itself with the latest technology. Nothing is
                    unachievable when our futuristic tools perform autonomously
                    and optimize your business activities to deliver results
                    beyond expectations.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4"></div>
          <div class="col-lg-2"></div>
        </div>
      </div>
    </div>
  </section>
  <section class="second-section">
    <div class="container-fluid">
      <div class="col-lg-12 text-center">
        <h1 class="emp">Empowering Business Owners to Achieve More</h1>
        <p class="expect">
          Expect more than what you want, receive more than what you expect.
          ONPASSIVE helps you achieve your business goals by connecting every
          missing dot with the help of innovative in-house built applications.
        </p>
      </div>
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-6" data-aos-easing="ease-out-cubic">
          <div class="text-box-1">
            <h3 class="point1">Business Automation</h3>
            <p>
              Receive end-to-end business automation through AI-driven
              applications and tools. Achieve reliable high performance with an
              automated business. Enable departments to deliver quantity with
              quality.
            </p>
          </div>
          <div class="shep-1">
            <img
              class="squar-img1"
              src="{{
                onPassiveBaseUrl
              }}onpassive(feb-06)/assets/image/squar1.png"
              alt="squar-img1"
            />
          </div>
        </div>
        <div class="col-xl-4 col-lg-6" data-aos-easing="ease-out-cubic">
          <div class="text-box-2">
            <h3 class="point1">Easy to Install</h3>
            <p>
              Transform your business with smart plug-n-play tools that
              auto-configure and sync with existing physical devices and
              functions. Users don&rsquo;t have to be tech-savvy for using these
              tools.
            </p>
          </div>
          <div class="shep-2">
            <img
              class="squar-img2"
              src="{{
                onPassiveBaseUrl
              }}onpassive(feb-06)/assets/image/squar2.png"
              alt="sqare2"
            />
          </div>
        </div>
        <div class="col-xl-4 col-lg-6" data-aos-easing="ease-out-cubic">
          <div class="text-box-3">
            <h3 class="point1">Expand Your Expectations</h3>
            <p>
              Acquire feasibility to streamline important business activities,
              such as sales, promotions, and customer relationship management
              (CRM), and establish a data-driven and self-operating operation in
              place.
            </p>
          </div>
          <div class="shep-3">
            <img
              class="squar-img3"
              src="{{
                onPassiveBaseUrl
              }}onpassive(feb-06)/assets/image/squar3.png"
              alt="squar3"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="third-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h1 class="third-section1">Animate Your Static Business</h1>
          <p class="text-white text-center get" data-aos-easing="linear">
            Get your standing still business moving with the help of tools
            designed for high productivity. Automate business operations and
            experience the power of artificial intelligence. Let the system
            decide the next plan of action based on information collected at
            various data points of your business. No human interference also
            reduces the chances of error and yields high accuracy.
          </p>
          <div class="row justify-content-center">
            <div class="col-lg-9">
              <div class="video-box mt-5">
                <video
                  autoplay="true"
                  class="
                    video-js video-size
                    w-100
                    h-auto
                    my-video-dimensions
                    shadow
                  "
                  controls=""
                  data-setup="{}"
                  id="my-video"
                  muted
                  poster="{{ myLinksS3URL }}images/Image0231.png"
                  preload="auto"
                >
                  <source
                    src="{{
                      myLinksS3URL
                    }}videos/Onpassive_launching_page_video2.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
              <a
                href="/registration/user?reg={{ userId }}"
                class="become_button"
                name="regform"
                target="_blank"
                rel="noopener"
                >Become a Founder Now</a
              >
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="fourth-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h1 class="testimonials-header">Testimonial</h1>
          <!------------------------------Testimonials-------------------------------------------->
          <!-- Testimonial Slider from Baamboo Studio modified for The Mentor Group (http://www.mentor-group.com/clients--testimonials.html) -->
          <!-- TestimonialS Slider - Free Weebly Widget by Baamboo Studio - Style 2 -->
          <div class="testimonial_slider_2">
            <input
              checked="checked"
              id="slide_2_1"
              name="slider_2"
              type="radio"
            />
            <input id="slide_2_2" name="slider_2" type="radio" />
            <input id="slide_2_3" name="slider_2" type="radio" />
            <input id="slide_2_4" name="slider_2" type="radio" />
            <div class="boo_inner clearfix">
              <div class="slide_content">
                <div class="testimonial_2">
                  <img
                    class="monials"
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(feb-06)/assets/image/1.jpg"
                    alt="1"
                  />
                  <div class="content_2">
                    <p>
                      <img
                        class="invited"
                        src="{{
                          onPassiveBaseUrl
                        }}onpassive(feb-06)/assets/image/invited.png"
                        alt="invited"
                      />
                      <!-- <img src="https://img.icons8.com/material-sharp/24/000000/quote-left.png"> -->ONPASSIVE
                      is the only door to success that opens for anyone who
                      knocks. If you decide to enter this door, it will be the
                      decision which will get you to the top. Just open your
                      eyes, it&#39;s not magic. ONPASSIVE gives you all the
                      tools and resources to make your dreams come true.
                      ONPASSIVE is not just an &quot;Artificial
                      Intelligence&quot; but financial freedom, prosperity,
                      success itself. I really do appreciate Ash Mufareh and his
                      Team! I feel that I am selected and happy to be a Founding
                      Member of ONPASSIVE. Thank you so much. If you are not yet
                      a Founder, come and step into the future. Time is NOW!
                      <!--  <img src="https://img.icons8.com/material-sharp/24/000000/quote-right.png">      -->
                    </p>
                  </div>
                  <div class="author_2">
                    <h3>Erzsebet Foldvari</h3>
                    <!--  <h4> erzsebet5691@gmail.com  </h4> -->
                    <h5>Hungary</h5>
                  </div>
                </div>
              </div>
              <div class="slide_content">
                <div class="testimonial_2">
                  <img
                    class="monials"
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(feb-06)/assets/image/2.jpg"
                    alt="2"
                  />
                  <div class="content_2">
                    <p>
                      <img
                        class="invited"
                        src="{{
                          onPassiveBaseUrl
                        }}onpassive(feb-06)/assets/image/invited.png"
                        alt="invited"
                      />ONPASSIVE gives me a bright future as a founder. I
                      joined back in 3-20-2019. True value was given to me &amp;
                      true value I will give back.
                      <!-- <img src="https://img.icons8.com/material-sharp/24/000000/quote-right.png">  -->
                    </p>
                  </div>
                  <div class="author_2">
                    <h3>Jeffery Mullen</h3>
                    <!--  <h4> jeffery.gofounders@gmail.com </h4> -->
                    <h5>United States</h5>
                  </div>
                </div>
              </div>
              <div class="slide_content">
                <div class="testimonial_2">
                  <img
                    class="monials"
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(feb-06)/assets/image/3.jpg"
                    alt="3"
                  />
                  <div class="content_2">
                    <p>
                      <img
                        class="invited"
                        src="{{
                          onPassiveBaseUrl
                        }}onpassive(feb-06)/assets/image/invited.png"
                        alt="invited"
                      />This idea of ONPASSIVE will be historically the
                      beginning of great prosperity in the world. This company
                      will go down in history of how many people became free
                      from the 9-5 rat race scam.
                      <!--  <img src="https://img.icons8.com/material-sharp/24/000000/quote-right.png">   -->
                    </p>
                  </div>
                  <div class="author_2">
                    <h3>Ty Young</h3>
                    <!--   <h4> youngty573@gmail.com  </h4> -->
                    <h5>United States</h5>
                  </div>
                </div>
              </div>
            </div>
            <div id="controls">
              <!--  <label for="slide_2_4"></label> -->
            </div>
          </div>
        </div>
        <!--------------------------------------------------------------------------------------->
      </div>
    </div>
  </section>
  <section class="fifth-section">
    <div class="container-fluid">
      <h1 class="testimonials-header text-center">Latest On The Blog</h1>
      <div class="row mt-5">
        <div class="col-lg-4 text-center" data-aos-easing="linear">
          <a href="https://onpassive.com/blog" target="_blank" rel="noopener"
            ><img
              class="blog-image"
              src="{{
                onPassiveBaseUrl
              }}onpassive(feb-06)/assets/image/gofounder.jpg"
              alt="o-founder"
            />
          </a>
        </div>
        <div class="col-lg-4 text-center" data-aos-easing="linear">
          <a href="https://onpassive.com/blog" target="_blank" rel="noopener"
            ><img
              class="blog-image"
              src="{{ onPassiveBaseUrl }}onpassive(feb-06)/assets/image/ai.jpg"
              alt="AI"
            />
          </a>
        </div>
        <div class="col-lg-4 text-center" data-aos-easing="linear">
          <a href="https://onpassive.com/blog" target="_blank" rel="noopener"
            ><img
              class="blog-image"
              src="{{
                onPassiveBaseUrl
              }}onpassive(feb-06)/assets/image/onpassive.jpg"
              alt="onpassive"
            />
          </a>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-12 text-center mb-4">
          <a
            class="btn btn-success btn-lg"
            href="https://onpassive.com/blog"
            target="_blank"
            rel="noopener"
            >SEE MORE</a
          >
        </div>
      </div>
    </div>
  </section>
  <section class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 text-center mt-3">
          <p class="text-white footer-content">
            &copy; 2022 ONPASSIVE - All Rights Reserved
          </p>
        </div>
      </div>
    </div>
  </section>
</body>
